import { listComplaints } from './listComplaints'
import { listSymptoms } from './listSymptoms'
import { listMedications } from './listMedications'
import { listDiagnosticHypotheses } from './listDiagnosticHypotheses'
import { uploadFiles, deleteUploadFile } from './uploadFiles'
import { updateForm } from './updateForm'
import { getForm } from './getForm'
import { updateDraft } from './updateDraft'

export default {
  listComplaints,
  listSymptoms,
  listMedications,
  listDiagnosticHypotheses,
  uploadFiles,
  deleteUploadFile,
  updateForm,
  getForm,
  updateDraft,
}
